/*
 * @Author: Zhouqi
 * @Date: 2025-11-08 15:26:26
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-11-12 19:34:51
 */
import { UploadFile } from 'antd/es/upload';

/**
 * 移除文件扩展名
 */
export const removeFileExtension = (filename: string): string => {
  return filename.replace(/\.[^/.]+$/, '');
};

/**
 * 在文件列表中更新或添加文件
 */
export const updateOrAddFile = (
  targetFile: UploadFile,
  list: UploadFile[],
): UploadFile[] => {
  const updatedList = list.map((f) => (f.uid === targetFile.uid ? targetFile : f));
  // 如果文件不在列表中，则添加
  if (!updatedList.find((f) => f.uid === targetFile.uid)) {
    updatedList.push(targetFile);
  }
  return updatedList;
};

/**
 * 获取文件大小的可读格式
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
};

// 导出时间工具
export * from './timeUtils';

// 导出单位转换工具
export * from './unit';

// 导出文件类型匹配工具
export * from './fileTypeMatch';

// 导出文件类型检测工具
export * from './fileTypeDetector';

// 导出图片尺寸获取工具
export * from './getImageDimensions';

// 导出分辨率解析工具
export * from './parseResolution';

// 导出宽高比解析工具
export * from './parseAspectRatio';
